import { Component } from '@angular/core';
import browserHelper from '@utils/browser-helper';

@Component({
  selector: 'app-mobile-apps-badges',
  templateUrl: './mobile-apps-badges.component.html',
  standalone: false
})
export class MobileAppsBadgesComponent {
  public shouldRender = !browserHelper.isInWrapper;
}
